define('home/templates/searchResults',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<ul class=\"nav-tabs tabs-5\">\n<li data-action=\"switch-tab\" data-tab=\"threads\" class=\"active\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"Threads",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</li>\n<li data-action=\"switch-tab\" data-tab=\"forums\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"Communities",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</li>\n<li data-action=\"switch-tab\" data-tab=\"users\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"Users",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</li>\n<li data-action=\"switch-tab\" data-tab=\"posts\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"Comments",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</li>\n<li data-action=\"switch-tab\" data-tab=\"myposts\">\n<a href=\"#\">\n"
    + alias2(helpers.gettext.call(alias1,"My Comments",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</li>\n</ul>\n\n<div data-role=\"content-area\"></div>\n<div data-role=\"footer-area\"></div>\n";
},"useData":true})

});
